<div fxLayout="column" class="dialog">
    <busy-indicator *ngIf="metadataLoading" page="true"></busy-indicator>
    <h2>Add Item</h2>
    <form #form="ngForm">
        <metadata-panel ngModelGroup="pnl_addDialog" *ngIf="!metadataLoading" metadata="metadata" model="entity">
        </metadata-panel>
    </form>
    <div *ngIf="hasError" class="error">{{saveError}}</div>

    <div fxLayout="row" fxLayoutAlign="end center">
        <command-bar telemetry="CmdBar-Commands-AddItem-Inventory" [commands]="commands"></command-bar>
    </div>
</div>
